interface StageUpgradeModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  currentStage: number
  nextStage: number
  // 스테이지 무료화로 포인트 관련 props는 사용하지 않지만 하위 호환성을 위해 유지
  nextStageCost?: number
  currentPoints?: number
  message: string
}

export default function StageUpgradeModal({
  isOpen,
  onClose,
  onConfirm,
  currentStage,
  nextStage,
  message,
}: StageUpgradeModalProps) {
  if (!isOpen) return null

  const getStageDescription = (stage: number) => {
    switch (stage) {
      case 1:
        return '상상의 단계 - 텍스트만'
      case 2:
        return '청각의 단계 - 음성 메시지'
      case 3:
        return '시각의 단계 - 사진 공개'
      default:
        return `Stage ${stage}`
    }
  }

  const getStageEmoji = (stage: number) => {
    switch (stage) {
      case 1:
        return '💭'
      case 2:
        return '👂'
      case 3:
        return '👀'
      default:
        return '✨'
    }
  }

  return (
    <div className="modal modal-open">
      <div className="modal-box max-w-md">
        <h3 className="font-bold text-lg mb-4">🎉 스테이지 업그레이드</h3>

        <div className="space-y-4">
          {/* 안내 메시지 */}
          <div className="alert alert-info">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm">{message}</span>
          </div>

          {/* 스테이지 진행 시각화 */}
          <div className="bg-gradient-to-r from-primary/10 to-secondary/10 p-4 rounded-xl space-y-4">
            <div className="flex items-center justify-center gap-4">
              {/* 현재 스테이지 */}
              <div className="text-center">
                <div className="text-3xl mb-1">{getStageEmoji(currentStage)}</div>
                <div className="text-sm font-medium">Stage {currentStage}</div>
                <div className="text-xs text-base-content/60">{getStageDescription(currentStage)}</div>
              </div>

              {/* 화살표 */}
              <div className="text-2xl text-primary animate-pulse">→</div>

              {/* 다음 스테이지 */}
              <div className="text-center">
                <div className="text-3xl mb-1">{getStageEmoji(nextStage)}</div>
                <div className="text-sm font-bold text-primary">Stage {nextStage}</div>
                <div className="text-xs text-base-content/60">{getStageDescription(nextStage)}</div>
              </div>
            </div>
          </div>

          {/* 무료 업그레이드 뱃지 */}
          <div className="alert alert-success">
            <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-sm font-medium">무료 업그레이드! 포인트가 차감되지 않습니다.</span>
          </div>

          <p className="text-xs text-center text-base-content/60">
            💕 상대방도 동의하면 스테이지가 업그레이드됩니다
          </p>
        </div>

        <div className="modal-action">
          <button onClick={onClose} className="btn btn-ghost">
            나중에
          </button>
          <button
            onClick={onConfirm}
            className="btn btn-primary"
          >
            동의하기 ✨
          </button>
        </div>
      </div>
      <div className="modal-backdrop bg-black/50" onClick={onClose}></div>
    </div>
  )
}
